import { render, staticRenderFns } from "./TarifvertragView.vue?vue&type=template&id=413fe7d2&"
import script from "./TarifvertragView.vue?vue&type=script&lang=js&"
export * from "./TarifvertragView.vue?vue&type=script&lang=js&"
import style0 from "./TarifvertragView.vue?vue&type=style&index=0&id=413fe7d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports